export default __webpack_public_path__ + "static/media/CarolineLogo.3ad959b3.png";